export default __webpack_public_path__ + "static/media/Group_8420.d8d74890.svg";